import React, { useEffect } from 'react';

import { ConversationAssistantNavBarButton } from '@confluence/conversation-assistant/entry-points/navBarButton.ts';
import { RovoEntitlementSetter } from '@confluence/conversation-assistant/entry-points/conversation-assistant-entitlement.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { AccessStatus } from '@confluence/session-data/entry-points/SiteInformationQuery.ts';
import { expValEquals } from '@confluence/feature-experiments';
import { CHAT } from '@confluence/named-routes/entry-points/routes.ts';
import { useIsOnRoute } from '@confluence/route-manager/entry-points/RouteState.ts';

export const RovoButton = (): React.JSX.Element => {
	const { isLoggedIn, isRovoLLMEnabled, accessStatus } = useSessionData();

	const isRovoEnabled =
		isRovoLLMEnabled && isLoggedIn && accessStatus !== AccessStatus.EXTERNAL_COLLABORATOR_ACCESS;

	const isOnFullPageChat = useIsOnRoute(CHAT);

	useEffect(() => {
		if (isRovoEnabled) {
			expValEquals('cc-aifc-databases-experiment', 'isEnabled', true);
		}
	}, [isRovoEnabled]);

	return (
		<>
			{isRovoEnabled && !isOnFullPageChat && <ConversationAssistantNavBarButton />}
			<RovoEntitlementSetter isRovoEnabled={isRovoEnabled} />
		</>
	);
};
